module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('article', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('div', {
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('section', {
    attrs: {
      "epub:type": "division"
    }
  }, [_c('h1', {
    staticClass: "chap_title",
    attrs: {
      "id": "c06"
    }
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }), _vm._v("c. 5000 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BCE")])]), _vm._v(" "), _c('h2', {
    staticClass: "section1"
  }, [_vm._v("Birth of Cosmology "), _c('span', {
    staticClass: "gray1"
  }, [_vm._v("• "), _c('em', [_vm._v("Jim Bell")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("In Greek, "), _c('em', [_vm._v("kosmos")]), _vm._v(" means “the universe,” and thus our modern word "), _c('em', [_vm._v("cosmology")]), _vm._v(" refers to the study of the nature, origin, and evolution of the universe. In the classical context, a society’s cosmology refers to its worldview or its way of thinking about where its people came from, why they are there, and where they are going. Civilizations throughout human history have created and nourished their cosmologies through creation stories, mythology, religion, philosophy, and, most recently, science.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We often hear (or read) such platitudes about how humanity has always been looking to the stars, or how our distant ancestors must have pondered the heavens in this way or that. While it’s fun to speculate, it’s impossible to know what prehistoric people were really thinking because (by definition) there’s no record of prehistory. That’s one reason why the oldest archaeological artifacts that depict or represent astronomical themes are so important: they provide some real data with which to try to understand how ancient people viewed the universe.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The oldest preserved evidence of a civilization pondering the heavens comes from the Sumerians, in their partial star maps or pieces of crude astronomical instruments that some scholars believe date to between 5,000 and 7,000 years ago. Even the scant fragments of information available from that time reveal a significant degree of sophistication in the Sumerians’ understanding of the motions of the Sun, Moon, major planets, and stars. Perhaps this is not surprising: the Sumerians built the first city-states supported by the cultivation of crops by a year-round, nonmigratory population. Knowing how to read the sky translated directly into knowing when to plant, irrigate, and harvest, and a stable food supply gave them time to invent writing, arithmetic, geometry, and algebra.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Sumerian cosmology appears to have been the first to make gods of the heavenly bodies, a practice inherited by later Babylonian, Greek, Roman, and other cosmologists. Sumerian cosmology also espoused the idea of many heavens and many Earths in what was a decidedly nongeocentric universe. It’s a worldview that resonates—surprisingly—with modern cosmological thinking, as the reality seems to be a universe without any center at all and apparently brimming with many Earths.")]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('strong', [_vm._v("SEE ALSO")]), _vm._v(" "), _c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781454933007_epub_c11_r1#c11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Egyptian Astronomy (c. 2500 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BCE")]), _vm._v(")")]), _vm._v(" "), _c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781454933007_epub_c37_r1#c37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sun-Centered Universe (1534)")]), _vm._v(", "), _c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781454933007_epub_c40_r1#c40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Telescope (1608)")]), _vm._v(", "), _c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781454933007_epub_c55_r1#c55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Newton’s Prism (1672)")]), _vm._v(", "), _c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781454933007_epub_c239_r1#c239",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hubble Telescope (1990)")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Reconstruction of an ancient Sumerian star chart from 3300 "), _c('span', {
    staticClass: "small2"
  }, [_vm._v("BCE")]), _vm._v(" known as the planisphere of Nineveh, which is believed to be one of the oldest astronomical instruments and data sets ever discovered.")])]), _vm._v(" "), _c('div', {
    staticClass: "title1"
  }, [_c('a', {
    attrs: {
      "id": "page23"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "id": "page23_1",
      "src": "Images/23-1.jpg"
    }
  })])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-796e50a8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/9781454933007_epub_c06_r1.vue
// module id = 87
// module chunks = 0